import React, { useState } from "react";
import Sidebar from "./Sidebar";
import resultado from "../assets/respuesta.PNG";
import resultado400 from "../assets/respuesta400.PNG";
import Header from "./Header";

const codeExample = `
const greet = (name) => {
  return 'Hello, ' + name;
};

console.log(greet('World'));
`;

const jsonExample = {
	CantReg: 1,
	PtoVta: 10,
	CbteTipo: 1,
	Concepto: 1,
	DocTipo: 80,
	DocNro: 21086148817,
	CbteDesde: 9,
	CbteHasta: 9,
	CbteFch: 20250325,
	ImpTotal: 100,
	ImpTotConc: 0,
	ImpNeto: 82.64,
	ImpOpEx: 0,
	ImpIVA: 17.36,
	ImpTrib: 0,
	FchServDesde: null,
	FchServHasta: null,
	FchVtoPago: null,
	MonId: "PES",
	MonCotiz: 1,
	CondicionIVAReceptorId: 1,
	CbtesAsoc: [
		{
			Tipo: 91,
			PtoVta: 1,
			Nro: 1,
			Cuit: 21249749293,
		},
	],
	Tributos: [
		{
			Id: 99,
			Desc: "Ingresos Brutos",
			BaseImp: 0,
			Alic: 0,
			Importe: 0,
		},
	],
	Iva: [
		{
			Id: 5,
			BaseImp: 82.64,
			Importe: 17.36,
		},
	],
};

// Componentes de Documentación
const Doc1 = () => (
	<div className="p-8">
		<h2 className="text-3xl font-semibold mb-4">
			¿Que necesito para usar el servicio?
		</h2>
		<p>
			Por cada uno de sus clientes, deberá tener habilitado los servicios desde
			ARCA conjuntamente con los certificados y claves para acceder desde
			nuestro servidor.
		</p>
		<br />
		<p>Para ello, deberá tener los siguientes datos:</p>
		<p>- Punto/s de venta generados para FE</p>
		<p>- Estar habilitado en RECE (Regimenes de facturacion y registracion)</p>
		<p>- Habilitar servicio de Factura electrónica</p>
		<p>- Generar clave y certificado</p>
		<p>
			- Desde cualquier lenguaje de programacion poder enviar una solicitud HTTP
			por POST con las datos de nuestro .json
		</p>
		<p>- Recibir respuesta de la solicitud HTTP</p>
		<br />

		{/* JSON de ejemplo */}
		<div className="mb-8">
			<h2 className="text-2xl font-semibold mb-4">Archivo JSON de Ejemplo</h2>
			<pre className="bg-gray-200 p-4 rounded-lg">
				<code>{JSON.stringify(jsonExample, null, 2)}</code>
			</pre>
		</div>
		<br />
		<h2 className="text-3xl font-semibold mb-4">Estructura del JSON</h2>

		<div className="section">
			<h3 className="text-2xl font-semibold mb-4">Campos Principales</h3>
			<ul>
				<li>
					<strong>CantReg (integer):</strong> Cantidad de registros en la
					solicitud.
				</li>
				<li>
					<strong>PtoVta (integer):</strong> Punto de venta.
				</li>
				<li>
					<strong>CbteTipo (integer):</strong> Tipo de comprobante.
				</li>
				<li>
					<strong>Concepto (integer):</strong> Concepto de la operación.
				</li>
				<li>
					<strong>DocTipo (integer):</strong> Tipo de documento del receptor.
				</li>
				<li>
					<strong>DocNro (integer):</strong> Número de documento del receptor.
				</li>
				<li>
					<strong>CbteDesde (integer):</strong> Número de comprobante desde.
				</li>
				<li>
					<strong>CbteHasta (integer):</strong> Número de comprobante hasta.
				</li>
				<li>
					<strong>CbteFch (integer):</strong> Fecha del comprobante en formato
					AAAAMMDD.
				</li>
				<li>
					<strong>ImpTotal (float):</strong> Importe total de la operación.
				</li>
				<li>
					<strong>ImpTotConc (float):</strong> Importe no gravado.
				</li>
				<li>
					<strong>ImpNeto (float):</strong> Importe neto sujeto a IVA.
				</li>
				<li>
					<strong>ImpOpEx (float):</strong> Importe de operaciones exentas.
				</li>
				<li>
					<strong>ImpIVA (float):</strong> Importe de IVA.
				</li>
				<li>
					<strong>ImpTrib (float):</strong> Importe total de tributos.
				</li>
				<li>
					<strong>FchServDesde (nullable integer):</strong> Fecha de inicio del
					servicio.
				</li>
				<li>
					<strong>FchServHasta (nullable integer):</strong> Fecha de
					finalización del servicio.
				</li>
				<li>
					<strong>FchVtoPago (nullable integer):</strong> Fecha de vencimiento
					de pago.
				</li>
				<li>
					<strong>MonId (string):</strong> Código de la moneda utilizada.
				</li>
				<li>
					<strong>MonCotiz (float):</strong> Cotización de la moneda respecto al
					peso argentino.
				</li>
				<li>
					<strong>CondicionIVAReceptorId (integer):</strong> Condición frente al
					IVA del receptor.
				</li>
			</ul>
		</div>

		<br />
		<h3 className="text-2xl font-semibold mb-4">Campos Anidados</h3>

		<h4 className="text-1xl font-semibold mb-4">
			Comprobantes Asociados (CbtesAsoc)
		</h4>
		<ul>
			<li>
				<strong>Tipo (integer):</strong> Tipo de comprobante asociado.
			</li>
			<li>
				<strong>PtoVta (integer):</strong> Punto de venta del comprobante
				asociado.
			</li>
			<li>
				<strong>Nro (integer):</strong> Número del comprobante asociado.
			</li>
			<li>
				<strong>Cuit (integer):</strong> CUIT del emisor del comprobante
				asociado.
			</li>
		</ul>
		<br />
		<h4 className="text-1xl font-semibold mb-4">Tributos (Tributos)</h4>

		<ul>
			<li>
				<strong>Id (integer):</strong> Código del tributo.
			</li>
			<li>
				<strong>Desc (string):</strong> Descripción del tributo.
			</li>
			<li>
				<strong>BaseImp (float):</strong> Base imponible del tributo.
			</li>
			<li>
				<strong>Alic (float):</strong> Alícuota aplicada.
			</li>
			<li>
				<strong>Importe (float):</strong> Importe total del tributo.
			</li>
		</ul>

		<br />
		<h4 className="text-1xl font-semibold mb-4">IVA (Iva)</h4>
		<ul>
			<li>
				<strong>Id (integer):</strong> Código de la alícuota de IVA aplicada.
			</li>
			<li>
				<strong>BaseImp (float):</strong> Base imponible sujeta a IVA.
			</li>
			<li>
				<strong>Importe (float):</strong> Importe de IVA calculado.
			</li>
		</ul>
	</div>
);

const Doc2 = () => (
	<div className="p-8">
		<h2 className="text-3xl font-semibold mb-4">Homologación</h2>
		<p>
			Nuestro servicio brinda un EndPoint para realizar pruebas en ambiente de
			Homologación
		</p>

		<br />
		{/* Código de ejemplo */}
		<div className="mb-8">
			<h2 className="text-2xl font-semibold mb-4">EndPoint</h2>
			<pre className="bg-gray-900 text-white p-4 rounded-lg">
				<code>http://167.99.146.81/api/fe</code>
			</pre>
			Se envia por POST el JSON de ejemplo.
			<br />
			<br />
			<h2 className="text-2xl font-semibold mb-4">Respuesta</h2>
			<p>
				- En el caso de una solicitud correcta, se devolverá un HTTP 200 OK,
				conjuntamente con un .json con 3 claves:{" "}
			</p>
			<br />
			<p>- Donde cada campo es:</p>
			<p>CAE = Validación suministrada por ARCA</p>
			<p>
				CAEFchVto: Fecha de vencimiento del CAE, tambien suministrada por ARCA
			</p>
			<p>
				Invoice: es el numero de comprobante que dio como respuesta la solicitud
				a ARCA
			</p>
			<img src={resultado} alt="resultado" width="250" height="91" />
			<p>
				- Ante cualquier error en el archivo del comprobante, error de ARCA o de
				nuestro servidor, recibirá un codigo de error correspondiente en el
				rango 300 al 500 dependiendo de cada caso.{" "}
			</p>
			<br />
			<p>- Aqui un ejemplo de un codigo de error 400: </p>
			<img src={resultado400} alt="resultado" width="1000" />
		</div>
	</div>
);

const Doc3 = () => (
	<div className="p-8">
		<h2 className="text-3xl font-semibold mb-4">Producción</h2>
		<p>
			Llego la hora de la verdad, esta todo listo para comenzar a emitir
			comprobantes 😅
		</p>
		<br />
		<p>¿Clientes registrados en nuestra WEB? ✅</p>
		<p>¿Trámites de ARCA completos? ✅</p>
		<p>¿Pruebas de implementacion en Homologación, hechas? ✅</p>
		<br />
		{/* Código de ejemplo */}
		<div className="mb-8">
			<h2 className="text-2xl font-semibold mb-4">EndPoint</h2>
			<pre className="bg-gray-900 text-white p-4 rounded-lg">
				<code>http://167.99.146.81/api/createInvoice/:id</code>
			</pre>
			El parámetro :id es el asociado al CUIT que quiere emitir el comprobante,
			lo obtiene desde la lista de cliente creados.
			<br />
			<br />
			<h2 className="text-2xl font-semibold mb-4">Respuesta</h2>
		</div>
	</div>
);

const Doc4 = () => (
	<div className="p-8">
		<h2 className="text-3xl font-semibold mb-4">Documentación de ARCA</h2>
		<p>- Normativa.</p>
		<p>- WebService.</p>
		<p>- Tablas del sistema.</p>
		<p>- Manuales.</p>
		<p>- Especificaciones.</p>

		<br />
		<a href="https://www.afip.gob.ar/fe/ayuda/webservice.asp" target="_blank">
			Link a documentación
		</a>
	</div>
);

const Documentation = () => {
	// Estado para controlar qué componente se muestra
	const [selectedDoc, setSelectedDoc] = useState("doc1");

	// Función para manejar el cambio de documentación
	const handleDocChange = (doc) => {
		setSelectedDoc(doc);
	};
	return (
		<>
			<Header />
			<div className="flex h-screen">
				{/* Menú lateral */}
				<Sidebar onDocChange={handleDocChange} />

				{/* Contenido derecho */}
				<div className="flex-1 p-4 bg-white">
					{selectedDoc === "doc1" && <Doc1 />}
					{selectedDoc === "doc2" && <Doc2 />}
					{selectedDoc === "doc3" && <Doc3 />}
					{selectedDoc === "doc4" && <Doc4 />}
				</div>
			</div>{" "}
		</>
	);
};

export default Documentation;
